/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface XMLExport
 */
export interface XMLExport {
    /**
     * 
     * @type {string}
     * @memberof XMLExport
     */
    contents: string;
}

export function XMLExportFromJSON(json: any): XMLExport {
    return XMLExportFromJSONTyped(json, false);
}

export function XMLExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): XMLExport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contents': json['contents'],
    };
}

export function XMLExportToJSON(value?: XMLExport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contents': value.contents,
    };
}


